<template>
    <el-card class="makina-list">
        <template slot="header">
            <el-row type="flex" justify="space-between">
                <h4>Koku Makinası Listesi</h4>
                <el-button icon="el-icon-plus" @click="add">Koku Makinası Ekle</el-button>
            </el-row>
        </template>

        <el-table v-loading="loading" :data="list" empty-text="Henuz Koku Makinası eklenmedi!">
            <el-table-column type="expand">
                <template slot-scope="{ row }">
                    <el-image
                            v-if="resimler[row.renk]"
                            :src="resimler[row.renk]"
                            fit="contain"
                            style="height: 250px; width: auto"/>
                </template>
            </el-table-column>
            <el-table-column prop="adi" label="Koku Makinası Adi"></el-table-column>
            <el-table-column prop="buyukluk" label="Koku Makinası Büyüklük"></el-table-column>
            <el-table-column prop="renk" label="Koku Makinası Renk"></el-table-column>
            <el-table-column>
                <template slot-scope="{ row }">
                    <img :src="resimler[row.renk]" style="width: 25px; height: auto">
                </template>
            </el-table-column>
            <el-table-column>
                <template slot-scope="{ row }">
                    <el-button icon="el-icon-edit" title="Güncelle" size="small" @click="update(row)"></el-button>
                    <el-button icon="el-icon-delete" title="Sil" size="small" type="danger"
                               @click="remove(row)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="`Koku Makinası ${ makina ? 'Güncelle' : 'Ekle'}`" :visible.sync="visible">
            <makina-form v-if="visible" :makina="makina" :visible="visible" @success="success"/>
        </el-dialog>
    </el-card>
</template>

<script>
    import MakinaForm from './MakinaForm.vue';
    import { resimler } from '@/common/kokular.js';

    export default {
        name: 'makina-list',
        components: {MakinaForm},
        data() {
            return {
                visible: false,
                loading: false,
                list: [],
                makina: null,
                resimler,
            };
        },
        methods: {
            add() {
                this.makina = null;
                this.visible = true;
            },
            update(makina) {
                this.makina = Object.assign({}, makina);
                this.visible = true;
            },
            remove(makina) {
                this.loading = true;
                this.$requests.Makina.deleteMakina(makina.id)
                    .then(() => {
                        console.debug('removed successfully', makina.id);
                        this.fetch();
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    })
            },
            success() {
                this.visible = false;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.$requests.Makina.getMakina()
                    .then((data) => {
                        this.list = data;
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.fetch();
        },
    }
</script>
